import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

interface RegenerateDialogProps {
  isOpen: boolean;
  onClose: () => void;
  comment: string;
  onCommentChange: (value: string) => void;
  onRegenerate: () => void;
  isGenerating?: boolean;
}

const RegenerateDialog = ({
  isOpen,
  onClose,
  comment,
  onCommentChange,
  onRegenerate,
  isGenerating = false,
}: RegenerateDialogProps) => {
  const handleRegenerate = () => {
    onRegenerate();
    // Close the dialog after regeneration starts
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Regenerate Response</DialogTitle>
          <DialogDescription>
            Add any specific instructions or comments for regenerating the response (optional)
          </DialogDescription>
        </DialogHeader>
        <Textarea
          value={comment}
          onChange={(e) => onCommentChange(e.target.value)}
          placeholder="E.g., Make it more formal, add more details about X, etc."
          className="min-h-[100px]"
          disabled={isGenerating}
        />
        <div className="flex justify-end space-x-2">
          <Button variant="outline" onClick={onClose} disabled={isGenerating}>
            Cancel
          </Button>
          <Button 
            onClick={handleRegenerate} 
            disabled={isGenerating}
          >
            {isGenerating ? "Regenerating..." : "Regenerate"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RegenerateDialog;